<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Apply Bank Account') }}</h3>
                <span class="fz-16 fw-400">{{ $t('Create an account tailored to your needs') }}</span>
            </div>

            <step-container
                :current_step="2"
                :step_list="stepList"
            ></step-container>
        </div>
        <b-container fluid class="mt-0 pb-5">
            <div id="body-container">
                <b-row>
                    <b-col xl="12">
                        <div class="p-0" v-if="init">
                            <LegalInfo
                                ref='legalInfo'
                                :information = information
                                :account_id = account_id
                                :user_no = user_no
                                @on-error = "onError"
                                @file-uploaded = "fileUploaded"
                                :doc_type_list = document
                            ></LegalInfo>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" class="d-flex">
                        <router-link to="/china-basic-information" class="btn btn-previous d-block mr-auto" tag="button">{{ $t('Previous') }}</router-link>
                        <button @click="nextStep" class="ml-auto btn btn-primary d-block">{{ $t('Next Step') }}</button>
                    </b-col>
                </b-row>
            </div>
      </b-container>
      <LoaderComponent v-if="isLoading || (isLoading === false && init === false)"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import stepContainer from "@/components/CardManagement/stepContainer";
    import LegalInfo from '@/components/CardManagement/legalInfo';
    import CreateAccount from '@/services/CreateAccount';
    import Account from "@/services/Account";
  
    export default {
        name: 'china-legal-information',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                init : false,
                account_id : '',
                user_no : '',
                information : '',
                stepList:["Basic Information","Legal Information", "Registered Address","Beneficiary Info"],
                document:[
                    {
                        "id":1,
                        "name":"ID Card"
                    },
                    {
                        "id":2,
                        "name":"Passport"
                    }
                ]
            }
        },
        components: {
            LoaderComponent,
            stepContainer,
            LegalInfo
        },
        methods:{
            nextStep(){
                this.isLoading = true;
                console.log("=== click next step ====")
                if(this.$refs['legalInfo'].validate()){
                    this.$refs['legalInfo'].uploadFile(this.account_id,this.user_no);
                }
                else{
                    this.isLoading = false;
                }
            },
            checkError(err){
                let self = this;
                try{
                    this.isLoading = false;
                    const response = err.response;  
                    if(response.status == 400){
                        console.log(response.data);
                        if(typeof response.data.message === 'string'){
                            this.$swal({
                                icon: 'info',
                                html:response.data.message,
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                        else{
                            if(response.data.message['errorMsg']){
                                this.$swal({
                                    icon: 'info',
                                    html:response.data.message['errorMsg'],
                                    showConfirmButton: true,
                                    confirmButtonText: self.getMessage('OK')
                                });
                            }
                            else{
                                let ret = [];
                                let legalInfo = this.$refs['legalInfo'];

                                Object.keys(response.data.message).forEach((key) => {
                                    let error = response.data.message[key][0];
                                    if(typeof legalInfo.error[key] !== "undefined"){
                                        legalInfo.error[key] = error;
                                    }
                                    
                                    if(key!="accountId"){
                                        ret.push(error);
                                    }
                                });

                                this.$swal({
                                    icon: 'info',
                                    html:ret.join("<br>"),
                                    showConfirmButton: true,
                                    confirmButtonText: self.getMessage('OK')
                                });
                            }
                        }
                    }      
                    else if(response.status == 401 && response.data.name == "Unauthorized"){
                            localStorage.removeItem("token");
                            localStorage.removeItem("member");
                            localStorage.removeItem("isFirstTime");
                            this.$router.push({ 
                                path: '/login', 
                            });
                    }
                    else{
                        if(localStorage.getItem("token")){
                            var msg = (response.data)?response.data.message:err.message;
                            this.$notify({
                                type: 'warn',
                                text: msg
                            })
                        }
                    }
                }catch(e){
                    console.log(err);
                }
            },
            onError(){
                this.isLoading = false;
            },
            fileUploaded(){
                
                let legal_info = this.$refs['legalInfo'];

                let params = {
                    "accountId":this.account_id,
                    "userNo":""+this.user_no,
                    "legalName" : legal_info.params.legalName,
                    "legalIdType" : legal_info.params.legalIdType,
                    "legalIdFront": legal_info.file.legalIdFront,
                    "legalIdReverse": legal_info.file.legalIdReverse,
                    "legalIdHold": legal_info.file.legalIdHold,
                    "legalRepresentative" :  legal_info.params.legalRepresentative,
                    "legalCountryCode" : "CHN",
                    "legalProvince" : legal_info.params.legalProvince,
                    "legalCity" : legal_info.params.legalCity,
                    "legalArea" : legal_info.params.legalArea,
                    "legalAddress" : legal_info.params.legalAddress,
                    "legalCertExpiryDate" : legal_info.params.legalCertExpiryDate,
                    "legalBirthDate" : legal_info.params.legalBirthDate,
                    "legalIdNo" : legal_info.params.legalIdNo
                };

                Account.updateChina(params).then(response => {
                    const data = response.data.data;
                    this.isLoading = false;
                    this.$router.push({ 
                        name: 'china-registered-address'
                    });
                }).catch(err => {
                    this.checkError(err);
                });
            }
        },
        mounted() {
            this.init = false;
            this.$nextTick(() => {
                CreateAccount.list({start:0, length:-1}).then((response)=>{
                    if (response.status == 200) {
                        if(response.data.data.length>0){
                            this.account_id = response.data.data[0]['id'];
                            this.user_no = response.data.data[0]['userNo'];
                            this.information = response.data.data[0]['information'];
                        }
                        this.init = true;
                    }
                });
            });
        },
    };
  </script>